interface DeleteConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * The "permanently delete this place" confirmation modal.
 *
 * Lifted verbatim from PlaceListModule's `deleteConfirmation && (...)` block.
 * State (`deleteConfirmation`) stays in the orchestrator; this leaf only fires
 * the two callbacks. Rendered only when there is a pending deletion.
 */
export function DeleteConfirmModal({ onCancel, onConfirm }: DeleteConfirmModalProps) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "25vh 16px 16px",
      }}
      onClick={onCancel}
    >
      <div
        style={{
          backgroundColor: "var(--color-surface)",
          borderRadius: "24px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Content */}
        <div
          style={{
            padding: "24px",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              color: "var(--color-text-subtle)",
              lineHeight: 1.6,
              margin: 0,
            }}
          >
            Are you sure you want to permanently delete this place?{" "}
            <strong>This action cannot be undone.</strong>
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "30px 24px 16px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "15px",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              background: "none",
              color: "var(--color-text-subtle)",
              border: "1px solid var(--color-border-strong)",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.15s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "var(--color-surface-hover)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "none";
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.background = "var(--color-border)";
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.background = "var(--color-surface-hover)";
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "8px 16px",
              background: "var(--color-danger)",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.15s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "var(--color-danger)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "var(--color-danger)";
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.background = "var(--color-danger-text)";
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.background = "var(--color-danger)";
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
